<div class="security-alternatives-container" id="security-alternatives-component">

  <div class="security-alternatives-container-row">
    <div class="security-alternatives-container-element">
      <div class="security-alternatives-element-label security-alternatives-add-header"> Tax Alternate & Account
        Type for Alternate (optional)
        <span id="addSecurityRestrictionsToolTipIcon"
              class="infoIcon" calltoaction
              [calltoactionTemplate]="securityAlternatesToolTipTemplateRef"></span>
      </div>

      <ng-template #securityAlternatesToolTipTemplateRef>
        <div>
          <p>These settings tell iRebal to purchase an alternate security that will be used in place of this
            security when trading in a certain account type. For example, if the subject security is a
            corporate bond fund, and you'd like to use a municipal bond fund in its place in taxable
            accounts, enter the symbol for the municipal bond fund in the alt sec field and select taxable
            as the alt acct type.</p></div>
      </ng-template>
    </div>
  </div>
  <div class="security-alternatives-container-row">
    <div class="security-alternatives-container-element">
      <div class="security-alternatives-element-label">Alt Sec</div>
      <div class="security-alternatives-element-input">
        <irb-dropdown-search
                #alternateSecurityDropdown
                [(value)]="selectedAltSecurity"
                (search)="getItemsForAlternateSecurityDropdown($event)"
                (selection)="onAlternativeSecurityChanged($event)"
                (clearSelection)="onAlternativeSecurityChanged({value: 0,name:null})"
                [placeholder]="alternateSecurityPlaceHolder"
                [addNewItem]="addNewSecurityItem"
                (openNewItemFlow)="openNewItemSecurityFlow($event)"
                size="14">
        </irb-dropdown-search>

      </div>

    </div>

    <div class="security-alternatives-container-element">
      <div class="security-alternatives-element-label">Alt acct</div>
      <div class="security-alternatives-element-input radio-btns" [class]="{'red-border' : tooltipDescMessage}"
           tooltip [tooltipTitle]="tooltipDescMessage" tooltipClass="" tooltipPosition="bottom">
        <p-radioButton name="INVERSE_ACCOUNT_TYPE" value="QUALIFIED"
                       [(ngModel)]="selectedInverseAccountType"
                       (ngModelChange)="onInverseAccountTypeChange()"
                       [disabled]="!selectedAltSecurity || (selectedAltSecurity.value == 0 || selectedAltSecurity.value == null)"
                       inputId="altitem1"></p-radioButton>
        <label for="altitem1">Qualified</label>
        <p-radioButton name="INVERSE_ACCOUNT_TYPE" value="TAXABLE"
                       [(ngModel)]="selectedInverseAccountType"
                       (ngModelChange)="onInverseAccountTypeChange()"
                       [disabled]="!selectedAltSecurity || (selectedAltSecurity.value == 0 || selectedAltSecurity.value == null)"
                       inputId="altitem2"></p-radioButton>
        <label for="altitem2">Taxable</label>
      </div>
    </div>
  </div>
</div>

